import {
  ICoherencePanelStyleProps,
  ICoherencePanelStyles,
} from "@coherence-design-system/controls";
import {
  FontSizes,
  ISearchBoxStyles,
  IStackProps,
  IStackStyles,
  IStackTokens,
  IStyleFunctionOrObject,
  ITextFieldStyles,
} from "@fluentui/react";
export const stackTokensWithGap5: Partial<IStackTokens> = { childrenGap: 5 };
export const stackTokensWithGap10: Partial<IStackTokens> = { childrenGap: 10 };
export const stackTokensWithGap20: Partial<IStackTokens> = { childrenGap: 20 };
export const stackTokensWithGap30: Partial<IStackTokens> = { childrenGap: 30 };
export const stackTokensWithGap40: Partial<IStackTokens> = { childrenGap: 40 };
export const stackTokensWithGap50: Partial<IStackTokens> = { childrenGap: 50 };
export const stackTokensWithGap70: Partial<IStackTokens> = { childrenGap: 70 };
export const stackTokensWithGap90: Partial<IStackTokens> = { childrenGap: 90 };
export const TextFont14 = {
  fontSize: FontSizes.size14,
  display: "inline",
};
export const GrayTextFont14 = {
  fontSize: FontSizes.size14,
  display: "inline",
  color: "#605E5C",
};
export const stackStyles: IStackStyles = {
  root: {
    marginLeft: "20px",
    marginRight: "10px",
  },
};
export const createFormStyle = {
  marginLeft: "20px",
  marginRight: "10px",
};
export const buttonStyleWithWidth100 = {
  width: "100px",
  marginTop: "20px",
  padding: "10px",
};
export const buttonStyleWithWidth200 = {
  width: "200px",
  marginTop: "20px",
  padding: "10px",
};
export const columnPropsWithHeight120: Partial<IStackProps> = {
  tokens: { childrenGap: 5 },
  styles: { root: { width: 300, height: 120, marginRight: 10 } },
};
export const columnPropsWithHeight150: Partial<IStackProps> = {
  tokens: { childrenGap: 5 },
  styles: { root: { width: 588, height: 150, marginRight: 10 } }, // Increased by 288px (4 inches) from 300px
};
export const columnHeaderCardProps: Partial<IStackProps> = {
  tokens: { childrenGap: 5 },
  styles: { root: { width: 300 } },
};
export const columnHeaderCardTokenProps: Partial<IStackProps> = {
  tokens: { childrenGap: 5 },
  styles: { root: { width: 200, overflowWrap:'break-word', margin:'2px' } },
};
export const textFieldStyles300 = {
  fieldGroup: { width: "300px" },
};
export const textFieldGrayStyles = {
  fieldGroup: {
    width: "290px",
    backgroundColor: "lightgray", // set the color to a lighter shade of gray
  },
};
export const textFieldGray: Partial<ITextFieldStyles> = {
  field: {
    backgroundColor: "lightgray",
  },
};
export const searchBoxStyles: Partial<ISearchBoxStyles> = {
  root: {
    width: 300,
    height: 32,
    minHeight: 32,
  },
  field: {
    fontSize: 14,
  },
};
export const searchBoxStylesWithHiddenIcon: Partial<ISearchBoxStyles> = {
  ...searchBoxStyles,
  iconContainer: {
    display: "none",
  },
};
export const OverridePanelPaddingStyle: IStyleFunctionOrObject<
  ICoherencePanelStyleProps,
  ICoherencePanelStyles
> = {
  footer: {
    background: "transparent", // Changed from pink to transparent to fix visual overlap
    zIndex: 1001, // Ensure footer is above search dropdown
    position: "relative" // Ensure proper positioning
  },
  // subComponentStyles: {
  //   panelStyles: {
  //     contentInner: {
  //       footer: {
  //         background: "green",
  //       },
  //     },
  //     footer: {
  //       background: "green",
  //     },
  //     footerInner: {
  //       background: "red",
  //     },
  //   },
  // },
};

export const TextFieldStyles = {
  fieldGroup: {
    width: "290px",
  },
};

export const TextGrayFieldStyles = {
  fieldGroup: {
    width: "290px",
    backgroundColor: "lightgray",
  },
};

export const TextStyle = {
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
  maxWidth: "200px",
};

export const NextButtonStyle = {
  width: "100px",
  padding: "10px",
  marginLeft: "1000px",
  marginBottom: "20px",
};

export const SaveButtonStyle = {
  width: "100px",
  marginTop: "20px",
  padding: "10px",
  marginLeft: "900px",
  marginBottom: "20px",
};

export const CancelButtonStyle = {
  width: "100px",
  marginTop: "20px",
  padding: "10px",
  marginBottom: "20px",
};

export const CheckBoxStyle = {
  root: {
    marginTop: "12px",
    width: "max-content",
  },
  checkbox: {
    height: "15px",
    width: "15px",
    marginTop: "28px",
    marginLeft: "10px",
  },
  text: {
    fontSize: "14px",
    fontWeight: "600",
    marginTop: "24px",
  },
};

export const ButtonStyle = {
  width: "100px",
  marginTop: "20px",
  padding: "10px",
};

export const CreateFormStyle = {
  marginLeft: "20px",
  marginRight: "10px",
};

export const MediumTextFieldStyles = {
  fieldGroup: {
    width: "200px",
  },
};

export const PanelCheckBoxStyle = {
  root: {
    marginTop: "12px",
    width: "max-content",
  },
  checkbox: {
    height: "15px",
    width: "15px",
    marginTop: "28px",
    marginLeft: "10px",
  },
  text: {
    fontSize: "14px",
    fontWeight: "600",
    marginTop: "24px",
  },
};

export const SeparatorStyles = {
  root: [
    {
      margin: 0,
      padding: 0,
      selectors: {
        "::before": {
          background: "lightgray",
          top: "0px",
        },
      },
    },
  ],
};
export const CardStyles = {
  layout: {
    margin: 0,
    padding: 0,
    paddingLeft: "30px",
  },
};
export const CardLayoutStyles = {
  layout: {
    margin: 0,
    padding: 0,
    paddingLeft: "30px",
    paddingRight: "30px",
    borderBottom: "2px solid lightgrey",
  },
};

export const CustomCardStyle = {
  root: {
    // maxHeight: 80
  },
  layout: {
    paddingBottom: 0,
    // paddingLeft: "30px",
    // paddingRight: "30px",
    borderBottom: "1px solid lightgrey",
  },
};
export const CustomCardForButtonsStyle = {
  layout: {
    padding: 0,
    margin: 0,
    borderBottom: "1px solid lightgrey",
  },
};

export const CustomSpanForListing = {
  color: "rgb(50, 49, 48)",
  // fontFamily: "Segoe UI", "Segoe UI Web (West European)", "Segoe UI", -apple-system, BlinkMacSystemFont, Roboto, "Helvetica Neue", sans-serif;
  lineHeight: "20px",
  fontSize: "14px",
  fontWeight: 400,
};

export const CustomSpanStyle = {
  fontFamily: "Segoe UI, Segoe UI Web (West European), Segoe UI, -apple-system, BlinkMacSystemFont, Roboto, Helvetica Neue, sans-serif",
  lineHeight: "20px",
  fontSize: "14px",
  fontWeight: 400,
  color: "rgb(50, 49, 48)"
}

export const CustomSpanStyleWithWordBreak = {
  fontFamily: "Segoe UI, Segoe UI Web (West European), Segoe UI, -apple-system, BlinkMacSystemFont, Roboto, Helvetica Neue, sans-serif",
  lineHeight: "20px",
  fontSize: "14px",
  fontWeight: 400,
  color: "rgb(50, 49, 48)",
  whiteSpace: "pre-wrap", /* Ensures that text wraps to the next line */
  wordBreak: "break-word", /* Breaks long words to avoid overflow */
  textAlign: "left"
}

export const CustomLeftAlignSpanStyle = {
  fontFamily: "Segoe UI, Segoe UI Web (West European), Segoe UI, -apple-system, BlinkMacSystemFont, Roboto, Helvetica Neue, sans-serif",
  lineHeight: "20px",
  fontSize: "14px",
  fontWeight: 400,
  color: "rgb(50, 49, 48)",
  textAlign:"left"
}

export const QuotationStackStyle: IStackStyles = {
    root: {
      background: "white", 
      overflowX: "hidden",     
    },
}

export const searchBoxIconWidthStyles: Partial<ISearchBoxStyles> = {
  root: { width: '45px', height: '32px', minHeight: '32px' },
};

export const searchBoxWidthStyles: Partial<ISearchBoxStyles> = {
  root: { width: '1200px', height: '32px', minHeight: '32px' }, // Increased by 262px more (total 550px increase from original 650px)
};

export const searchIconStyle = {
  color: "rgb(0, 90, 158)",
  fontSize: "16px",
  marginLeft: "5px",
  marginTop: "0px",
  padding: "0px", // Remove padding to match exact height
  cursor: "pointer",
  borderTopRightRadius: "5px",
  borderBottomRightRadius: "5px",
  height: "32px", // Exact match with SearchBox height
  minHeight: "32px", // Exact match with SearchBox minHeight
  width: "32px", // Make it square for perfect alignment
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  boxSizing: "border-box" as const
};
